<template>
  <card class="form-card">
    <template slot="header">
      <div class="form-title">{{ title }}</div>
      <div class="form-explainer">
        {{ email_explainer }}
      </div>
    </template>
    <template>
      <div class="form-explainer">
        {{ spam_explainer }}
      </div>
    </template>
  </card>
</template>

<script>
  import Card from '@/components/UIComponents/Cards/Card.vue'
  
  export default {
    components: {
      Card,
    },
    data: function () {
      return {
        title: "Reset Instructions Sent",
        email_explainer: "We've emailed you instructions for resetting your password. You should receive an email from us shortly.",
        spam_explainer: "If you don't receive an email, please check your spam folder and make sure you've entered the email address you registered with.",
      }
    },
  }
</script>
